import { capitalize, Divider, Stack } from '@mui/material';
import { PublicOutlined, VolumeUpOutlined, WcOutlined } from '@mui/icons-material';
import { ListItemContainer, ListItemContent, ListItemProps } from './ListItem';
import { TTSVoice, TTSVoiceAWS, TTSVoiceAzure, TTSVoiceElevenLabs, TTSVoiceTelnyx } from '@requests/telnyx';

export const TTSVoiceListItem: React.FC<ListItemProps<TTSVoice>> = (props) => {
  const { option, key, ...liProps } = props;

  return (
    <ListItemContainer key={key} {...liProps}>
      <Stack>
        <VolumeUpOutlined sx={{ fontSize: '20px' }} />
      </Stack>
      {option.provider === 'elevenlabs' && <ElevenLabsContent voice={option} />}
      {option.provider === 'azure' && <AzureContent voice={option} />}
      {option.provider === 'aws' && <AWSContent voice={option} />}
      {option.provider === 'telnyx' && <KokoroContent voice={option} />}
    </ListItemContainer>
  );
};

const AWSContent: React.FC<{ voice: TTSVoiceAWS }> = ({ voice }) => {
  return (
    <ListItemContent>
      <Stack direction='row' justifyContent='space-between' alignItems='center'>
        <h1>{voice.name}</h1>
        <Stack mt={0.5} direction='row' spacing={1.5} divider={<Divider flexItem orientation='vertical' />}>
          {voice.gender && (
            <Stack spacing={0.75} direction='row' alignItems='center'>
              <p id='smallNoWrap'>{voice.gender}</p>
            </Stack>
          )}
          {voice.language && (
            <Stack spacing={0.75} direction='row' alignItems='center'>
              <p id='smallNoWrap'>{voice.language}</p>
            </Stack>
          )}
        </Stack>
      </Stack>
    </ListItemContent>
  );
};

const AzureContent: React.FC<{ voice: TTSVoiceAzure }> = ({ voice }) => {
  return (
    <ListItemContent>
      <Stack direction='row' justifyContent='space-between' alignItems='center'>
        <h1>{voice.name}</h1>
        <Stack mt={0.5} direction='row' spacing={1.5} divider={<Divider flexItem orientation='vertical' />}>
          {voice.gender && (
            <Stack spacing={0.75} direction='row' alignItems='center'>
              <p id='smallNoWrap'>{voice.gender}</p>
            </Stack>
          )}
          {voice.language && (
            <Stack spacing={0.75} direction='row' alignItems='center'>
              <p id='smallNoWrap'>{voice.language}</p>
            </Stack>
          )}
        </Stack>
      </Stack>
    </ListItemContent>
  );
};

const ElevenLabsContent: React.FC<{ voice: TTSVoiceElevenLabs }> = ({ voice }) => {
  return (
    <ListItemContent>
      <Stack direction='row' justifyContent='space-between' alignItems='center'>
        <h1>{voice.name}</h1>
        <Stack mt={0.5} direction='row' spacing={1.5} divider={<Divider flexItem orientation='vertical' />}>
          {voice.accent && (
            <Stack spacing={1} direction='row' alignItems='center'>
              <p id='smallNoWrap'>{voice.accent}</p>
              <PublicOutlined sx={{ fontSize: '13px' }} />
            </Stack>
          )}
          {voice.gender && (
            <Stack spacing={1} direction='row' alignItems='center' sx={{ minWidth: '60px' }}>
              <p id='smallNoWrap'>{voice.gender}</p>
              <WcOutlined sx={{ fontSize: '13px' }} />
            </Stack>
          )}
        </Stack>
      </Stack>
    </ListItemContent>
  );
};

export const formatKokoroVoiceName = (voice: TTSVoice) => {
  try {
    return capitalize(voice.name.split('_')[1]);
  } catch (error) {
    return voice.name;
  }
};

const KokoroContent: React.FC<{ voice: TTSVoiceTelnyx }> = ({ voice }) => {
  return (
    <ListItemContent>
      <Stack direction='row' justifyContent='space-between' alignItems='center'>
        <h1>{formatKokoroVoiceName(voice)}</h1>
        <Stack mt={0.5} direction='row' spacing={1.5} divider={<Divider flexItem orientation='vertical' />}>
          {voice.language && (
            <Stack spacing={1} direction='row' alignItems='center'>
              <p id='smallNoWrap'>{voice.language}</p>
              <PublicOutlined sx={{ fontSize: '13px' }} />
            </Stack>
          )}
        </Stack>
      </Stack>
    </ListItemContent>
  );
};
